<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>日期：</b>
      <el-date-picker
          style="width: 120px;"
          v-model="queryParams.stime"
          type="date"
          placeholder="请输入盘库日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
      </el-date-picker>
      <b>仓库：</b>
      <el-select v-model="queryParams.cs" placeholder="请选择" style="    width: 120px">
        <el-option
            v-for="item in ckList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary" @click="createdata" size="medium" round><i class="el-icon-circle-plus"></i>新建盘库计划
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>

    </div>

    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column

          label="盘库计划"
          prop="name" align="center">
        <template slot-scope="scope">
          <div style="color: blue;float:left" @click="openpk(scope.row,0)">{{ scope.row.name ?? '' }}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="开始时间" :formatter="formatDates"
          prop="stime" align="center">
      </el-table-column>
      <el-table-column
          label="结束时间" :formatter="formatDatee"
          prop="etime" align="center">
      </el-table-column>

      <el-table-column
          align="center" label="操作" width="250">

        <template slot-scope="scope">
          <el-button v-if="scope.row.state=='1'"
                     size="mini"
                     @click="handleEdit( scope.row)">
            <i class="el-icon-setting"></i>
            修改
          </el-button>
          <el-button v-if="scope.row.state=='1'"
                     type="success"
                     size="mini"
                     @click="endStock(scope.$index, scope.row)">
            <i class="el-icon-success"></i>
            结束
          </el-button>
          <el-button v-if="scope.row.state=='2'"
                     size="mini"
                     @click="printStock( scope.row)">
            <i class="el-icon-download"></i>
            打印结果
          </el-button>
          <el-button v-if="scope.row.state=='1'"
                     size="mini"
                     type="danger"
                     @click="deleterole(scope.$index, scope.row)"><i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template>
      <div>

        <pagination
            id="companyListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>


    <el-dialog :title="title" :visible.sync="dialogFormVisible" id="stockDialog">
      <el-form :model="selectTable">
        <el-form-item label="仓库:" label-width="100px">
          <el-select v-model="selectTable.wid" placeholder="请选择" style="width: 100%" :disabled="selectTable.id>0">
            <el-option
                v-for="item in ckList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库类型:" label-width="100px" :disabled="selectTable.id>0">
          <el-select v-model="selectTable.stype" placeholder="请选择" style="width: 100%">
            <el-option
                v-for="item in pkList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库产品选择:" label-width="100px" v-if="selectTable.stype=='0'">
          <el-checkbox-group v-model="checkboxGroup2" size="mini">
            <el-checkbox
                v-for="item in spList"
                :key="item.id"
                :label="item.id"
                border
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="盘库页面" destroy-on-close :visible.sync="dialogFormVisiblepk" :fullscreen="true" id="pkDialog">
      <quickStock :sid="sid" :diaflag="diaflag" :sname="sname"></quickStock>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";
import quickStock from '@/inventory/QuickStock.vue'

export default {
  components: {Pagination, quickStock},
  data() {
    return {
      checkboxGroup2: [],
      TitleInfo: {
        name: undefined,
        type: 'kh',
        state: '1',
      },
      ckList: [],
      spList: [],
      pkList: [{id: '0', name: '部分产品'}, {id: '1', name: '全部'}],
      total: 0,
      queryParams: {
        stime: undefined,
        cs: undefined,
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        person: undefined,
        status: 1
      },
      title: '新建盘库计划',
      selectTable: {
        title: '',
        id: 0,
        wid: undefined,
        state: "1",
        stype: '1',
        pids: '',
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      menuOptions: [],
      sid: undefined,
      diaflag: false,
      sname: undefined,
      dialogFormVisiblepk: false,
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.getck();
    this.getsp();
  },

  methods: {
    openpk(row) {
      this.sid = row.id
      this.diaflag = row.state === '2'
      this.sname = row.name
      this.dialogFormVisiblepk = true
    },
    formatDates(row) {
      const timestamp = row.stime;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
      return formattedDate;
    },
    formatDatee(row) {
      const timestamp = row.etime;
      if (timestamp == null) {
        return '未结束'
      }
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
      return formattedDate;
    },
    getsp() {
      this.$request.postHttp({
        url: "/basic/getsp",
        success: (data) => {
          this.spList = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getck() {
      this.$request.postHttp({
        url: "/basic/getck",
        success: (data) => {
          this.ckList = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/stockList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    printStock(row) {
      this.$request.postHttp({
        url: "/basic/stockExport",
        params: {id: row.id},
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('导出成功正在下载！')
            const link = document.createElement('a');
            link.href = data.msg;
            link.download = '装配单列表'; // 设置下载文件名
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


          } else {
            this.$message.warning(data.msg)
          }

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    deleterole(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/basic/delStock",
          params: {id: row.id},
          success: (data) => {
            this.$message.success('删除成功！')

            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    endStock(index, row) {
      this.$confirm('确认结束吗?结束后会生成总结文件。', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/basic/endStock",
          params: {id: row.id},
          success: (data) => {
            this.$message.success('计划已结束！进入打印')
            this.getList();
            this.printStock(row)
          },
          error: (error) => {
            this.$message.error('操作失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    createtree() {
      const selectedIds = this.checkboxGroup2.join(',');
      if (selectedIds.length === 0 && this.selectTable.stype == '0') {
        this.$message.warning('请至少选择一条产品数据');
        return;
      }
      if (this.selectTable.wid === undefined || this.selectTable.wid === 0) {
        this.$message.warning('请选择需要盘的仓库');
        return;
      }
      this.selectTable.pids = selectedIds;
      this.$request.postHttp({
        url: "/basic/saveStock",
        data: JSON.stringify(this.selectTable),
        success: (data) => {
          this.$message.success(data.msg)
          this.dialogFormVisible = false
          this.getList();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    createdata() {
      this.checkboxGroup2 = this.$options.data().checkboxGroup2
      this.selectTable = this.$options.data().selectTable
      this.title = '新建盘库计划';
      this.dialogFormVisible = true

    },
    handleEdit(row) {
      this.$request.postHttp({
        url: "/basic/getStock",
        params: {id: row.id},
        success: (data) => {
          this.selectTable = data.data
          this.title = '修改计划'
          this.dialogFormVisible = true;
          this.checkboxGroup2 = data.data.pids.split(",").map(Number);

        },
        error: (error) => {
          this.$message.error('打开失败！')
          // 执行失败时的操作
        },
      })
    },


  },
  computed: {}
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

#stockDialog .el-checkbox.is-bordered.is-checked {
  background-color: #b8dcff !important;
}

selectupwidth el-select {
  width: 120px;
}

#pkDialog .el-dialog__body {
  padding: 0px 10px
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>